import { render, staticRenderFns } from "./suplidosF.vue?vue&type=template&id=72823b22"
import script from "./suplidosF.vue?vue&type=script&lang=js"
export * from "./suplidosF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports